import { format } from "date-fns";

export function getTodayDateString() {
  return format(new Date(), "yyyy-MM-dd");
}

export function mapApiDetailsToFormErrors(details) {
  if (!details || typeof details !== "object") return {};
  return Object.fromEntries(
    Object.entries(details).map(([k, v]) => [k, String(v ?? "")]),
  );
}

export function safeErrorText(err, fallback = "Something went wrong. Please try again.") {
  const m = err?.message;
  return typeof m === "string" && m.trim() ? m : fallback;
}

export function formatStaffDepartmentLabel({ department_name, role_name, role_slug } = {}) {
  const fromName = String(department_name ?? role_name ?? "").trim();
  if (fromName) return fromName;
  const slug = String(role_slug ?? "")
    .trim()
    .toLowerCase();
  const labels = {
    office: "Office",
    admin: "Admin",
    receptionist: "Reception",
    recep: "Reception",
    reception: "Reception",
    volunteer: "Volunteer",
    staff: "Staff",
  };
  return labels[slug] || slug || "";
}

/** Admin directory — creator name plus role (Office, Admin, etc.). */
export function formatCreatedByDisplay(row) {
  const name = String(row?.created_by_name ?? "").trim();
  const roleLabel = formatStaffDepartmentLabel({
    role_name: row?.created_by_role_name,
    role_slug: row?.created_by_role_slug,
  });
  if (!name && !roleLabel) return "—";
  if (!roleLabel) return name;
  if (!name) return roleLabel;
  return `${name} (${roleLabel})`;
}

export function formatPersonWithDepartment(name, meta = {}) {
  const n = String(name ?? "").trim();
  const dept = formatStaffDepartmentLabel(meta);
  if (!n && !dept) return "—";
  if (!dept) return n;
  if (!n) return dept;
  return `${n} (${dept})`;
}

export async function ensureCsrfToken(getCsrfToken) {
  let token =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("csrf_token") || localStorage.getItem("csrf-token")
      : null;
  if (!token) {
    token = await getCsrfToken();
    if (token && typeof localStorage !== "undefined") {
      localStorage.setItem("csrf_token", token);
      localStorage.setItem("csrf-token", token);
    }
  }
  return token;
}

export function scheduleIdText(row) {
  return String(row?.schedule_code || row?.schedule_id || row?.id || "").trim();
}

export function formatTimeCell(value) {
  if (!value) return "—";
  const s = String(value);
  return s.length >= 5 ? s.slice(0, 5) : s;
}
